import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=e24bcb68&"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js&"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24bcb68')) {
      api.createRecord('e24bcb68', component.options)
    } else {
      api.reload('e24bcb68', component.options)
    }
    module.hot.accept("./SidebarMinimizer.vue?vue&type=template&id=e24bcb68&", function () {
      api.rerender('e24bcb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/SidebarMinimizer.vue"
export default component.exports